import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var Hangouts = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "m20.739 14.293-1.354 2.732h-2.031l1.354-2.732h-2.032v-4.098h4.062v4.098zm-5.416 0-1.354 2.732h-2.031l1.354-2.732h-2.031v-4.098h4.062v4.098zM16 2C9.636 2 4.491 7.19 4.491 13.61S9.636 25.22 16 25.22h.677v4.781c6.634-3.142 10.832-10.244 10.832-16.39 0-6.42-5.146-11.61-11.509-11.61z" }))); }));
Hangouts.displayName = 'Hangouts';
Hangouts['iconName'] = 'hangouts';
export default Hangouts;
